import { CalcualtionResultKeys } from '../modules/Constants.js';
import { ncasIRR } from '../modules/Irr.js';

export class CalculationHelper {
    firstYearCalculation(partData, volumes, partKey, mapping) {

        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX) });
            return index !== -1;
        });
        let years = data.map(c => c.year);
        let min = Math.min(...years);
        let total = data.filter(d => d.year === min).map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + curValue, 0);
        let cl = (total / volumes[partKey].first);

        return cl;
    }

    perPcCalculation(partData, volumes, partKey, mapping) {
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX)});

            return index !== -1;
        });

        let total = data.map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + curValue, 0);
        let cl = (total / volumes[partKey].total);

        return cl;
    }

    totalCalculation(partData, mapping) {
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX)});

            return index !== -1;
        });

        let total = data.map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + curValue, 0);

        return total;
    }

    programAverageCalculation(partData, volumeTotal, mapping) {
        var total = this.totalCalculation(partData, mapping);

        return this.getNumber(total / volumeTotal);
    }

    totalCalculationIgnoreNegatives(partData, mapping) {
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX) });

            return index !== -1;
        });

        let total = data.map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + (curValue < 0 ? 0 : curValue), 0);

        return total;
    }

    perYearTotalCalculation(partData, mapping) {
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX) });

            return index !== -1;
        });

        let result = {};
        let years = data.map(c => c.year);

        years.forEach(year => {
            result[year] = data.map(x => x).filter(x => x.year === year).map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + this.getNumber(curValue), 0);
        })

        return result;
    }

    perYearPerPcCalculation(partData, volumes, mapping) {
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX) });

            return index !== -1;
        });

        let result = {};
        let years = data.map(c => c.year);

        years.forEach(year => {
            let yearVolume = 0;
            for (var vKey in volumes) {
                yearVolume += (volumes[vKey].years[year] ?? 0);
            }

            result[year] = (data.map(x => x).filter(x => x.year === year).map(d => d.displayValue).reduce((accumVariable, curValue) => accumVariable + this.getNumber(curValue), 0)) / yearVolume;
        })

        //console.log(volumes);

        return result;

    }

    hasNewMaterialBucket(partData) {
        var mapping = [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]
        let data = partData.filter(item => {
            let index = mapping.findIndex(look => { return look.key === item.input && look.line === item.label && item.valueScope.startsWith(CalcualtionResultKeys.VALUE_SCOPE_GLOBAL_PREFIX) });

            return index !== -1;
        });

        return data.length > 0;
    }

    irr(cashflows) {
        try {
            return ncasIRR(cashflows);
        }
        catch (e) {
            return NaN
        }
    }

    getNumber(value) {
        return Number.isNaN(value) ? 0 : value;
    }

    getPartKey(part) {
        let number = part.Part?.Number?.Fields[0] ?? "";
        let Rev = part.Part?.DrawingRevision?.Fields[0]?.Fields[0] ?? "";
        let suffix = part.Part?.Suffix?.Fields[0]?.Fields[0] ?? "";

        let key = number + "|" + Rev + "|" + suffix;

        return key;
    }

    getAdjustment(adjustments, adjustmentType, volumes) {
        let adjustmentsList = adjustments?.map(x => x)?.filter(x => x?.Type?.Case === adjustmentType).map(x => x?.Adjustments[0]?.Value?.Fields)[0]?.reduce(function (a, b) { return a.concat(b) }, []);
        let adjustmentYears = adjustmentsList?.filter(x => x?.Date !== undefined && x?.Value > 0);
        let groupedAdjustments = adjustmentYears?.reduce((map, e) => ({
                ...map,
            [e.Value]: [...(map[e.Value] ?? []), e]
        }), {});

        var adjustmentLines = [];
        for (var gKey in groupedAdjustments) {
            if (isNaN(gKey) == false) {
                adjustmentLines.push(groupedAdjustments[gKey].length + " x " + (gKey * 100) + "%");
            }
        }

        let result = adjustmentLines.join(" & ");

        if (result == false) {
            let _adjustment = adjustments?.map(x => x)?.filter(x => x?.Type?.Case === adjustmentType)
            let adjustmentYears1 = _adjustment[0]?.Adjustments[0]?.Parameter?.Fields[0]?.Fields[0];
            let adjustmentValue1 = _adjustment[0]?.Adjustments[0]?.Parameter?.Fields[1]?.Fields[0] * 100 ?? 0
            let adjustmentYears2 = _adjustment[0]?.Adjustments[0]?.Parameter?.Fields[2]?.Fields[0];
            let adjustmentValue2 = _adjustment[0]?.Adjustments[0]?.Parameter?.Fields[3]?.Fields[0] * 100 ?? 0

            if (adjustmentYears1 == undefined || adjustmentYears2 == undefined) {
                let numberOfVolumeYears = 0;
                for (var vKey in volumes) {
                    let minVolumeYear = volumes[vKey].years.findIndex(num => { return num > 0; })
                    let maxVolumeYear = volumes[vKey].years.length;

                    if (maxVolumeYear - minVolumeYear > numberOfVolumeYears) {
                        numberOfVolumeYears = maxVolumeYear - minVolumeYear;
                    }
                }
                if (adjustmentYears1 == undefined) {
                    adjustmentYears1 = numberOfVolumeYears - 1;
                }
                if (adjustmentYears2 == undefined) {
                    adjustmentYears2 = numberOfVolumeYears - 1;
                }
            }
            if (isNaN(adjustmentValue1) == false) {
                result = adjustmentYears1 + " x " + adjustmentValue1 + "%";
            }
            if (isNaN(adjustmentValue2) == false) {
                result += " & " + adjustmentYears2 + " x " + adjustmentValue2 + "%";
            }
        }

        return result;
    }

    findFirstYearIndexHelper(data) {
        return Object.values(data).findIndex(val => val !== 0) ?? 0;
    }

    exchangeValue(value, exchangeRates, year, currency, targetCurrency) {
        if (currency === '') {
            currency = 'USD';
        }

        let rates = {
            original: exchangeRates.find(rate => rate.year === year && rate.currency === currency),
            selected: exchangeRates.find(rate => rate.year === year && rate.currency === targetCurrency)
        };

        let result = {
            originalValue: value, 
            displayValue: null
        }

        if (value === 0) {
            result.originalValue = 0;
            result.displayValue = 0;
        } else {
            result.originalValue = value / rates?.original?.value;
            result.displayValue = value * rates?.selected?.value;
        }

        return result;
    }
}


export class CalculationModel {
    input = "";
    label = "";
    tag = "";
    value = "";
    partNumber = "";
    year = "";
    documentationKey = "";
    objectType = "";
    groupName = "";
    valueScope = "";
    division = "";
    productGroup = "";
    plantNumber = "";
    currency = "USD";

    constructor(calculationText, calculation, val, amount, exchangeRates, currency) {

        this.input = calculationText,
        this.label = calculation.value.lineLabel,
        this.tag = val.amount.tag,
        this.value = amount.value,
        this.partNumber = val.saleablePartId.partNumber,
        this.partRev = val.saleablePartId.drawingRevision,
        this.partSuffix = val.saleablePartId.suffix
        this.year = amount.date.year,
        this.documentationKey = calculation.value.documentationKey,
        this.objectType = calculation.value.objectType,
        this.groupName = val.groupName,
        this.valueScope = val.valueScope,
        this.division = val.location.division,
        this.productGroup = val.location.productGroup,
        this.plantNumber = val.location.plant.plantNumber
        this.currency = currency

        this.exchange(exchangeRates);

    }

    exchange(exchangeRates) {
        if (this.tag === '') {
            this.tag = 'USD';
        }

        let rates = {
            original: exchangeRates.find(rate => rate.year === this.year && rate.currency === this.tag),
            selected: exchangeRates.find(rate => rate.year === this.year && this.currency === rate.currency)
        };

        if (this.value === 0) {
            this.originalValue = 0;
            this.displayValue = 0;
        } else {
            this.originalValue = this.value / rates?.original?.value;
            this.displayValue = this.originalValue * rates?.selected?.value;
        }
    }

}